export default "__VITE_ASSET__wdrToJPc__"